/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SiteConfigurationKey = {
    SANCTIONED_COUNTRIES: 'SANCTIONED_COUNTRIES',
    RESTAURANT_SEARCH_HERO: 'RESTAURANT_SEARCH_HERO',
    GO_FRENS_HERO: 'GO_FRENS_HERO',
    GO_VIP_HERO: 'GO_VIP_HERO',
    FUEL_HERO: 'FUEL_HERO',
    INDUSTRY_PAGE_HERO: 'INDUSTRY_PAGE_HERO',
    REWARDS_FUEL_MENU_ORDERS: 'REWARDS_FUEL_MENU_ORDERS',
    MENU_ORDER_DELIVERY_CHARGE: 'MENU_ORDER_DELIVERY_CHARGE',
    DEFAULT_MARKETPLACE_FEE_DELIVERY: 'DEFAULT_MARKETPLACE_FEE_DELIVERY',
    DEFAULT_MARKETPLACE_FEE_PICKUP: 'DEFAULT_MARKETPLACE_FEE_PICKUP',
    INDUSTRY_PROMO_BANNER: 'INDUSTRY_PROMO_BANNER',
    DEVOURIQ: 'DEVOURIQ',
    FUEL_LOADS_REWARD: 'FUEL_LOADS_REWARD',
    INDUSTRY_PASS_PURCHASE_REWARD: 'INDUSTRY_PASS_PURCHASE_REWARD',
    REFER_A_FRIEND_FIRST_ORDER_REWARD: 'REFER_A_FRIEND_FIRST_ORDER_REWARD',
    SIGN_UP_REWARD: 'SIGN_UP_REWARD',
    LEVEL_UP_FUEL_REWARD: 'LEVEL_UP_FUEL_REWARD',
    LEVEL_UP_GO_VIP_POINT_REWARD: 'LEVEL_UP_GO_VIP_POINT_REWARD',
    OW_ANNOUNCEMENT_MODAL: 'OW_ANNOUNCEMENT_MODAL',
    ALCHEMY_WEBHOOK_ETHEREUM: 'ALCHEMY_WEBHOOK_ETHEREUM',
    ALCHEMY_WEBHOOK_BASE: 'ALCHEMY_WEBHOOK_BASE',
    ALCHEMY_WEBHOOK_POLYGON: 'ALCHEMY_WEBHOOK_POLYGON',
    NFT_SALE_PAYMENT_METHODS: 'NFT_SALE_PAYMENT_METHODS',
    FUELUP_DOLLARS_PER_MOVE: 'FUELUP_DOLLARS_PER_MOVE',
    LOOTSHOP_AUTO_DISTRIBUTION: 'LOOTSHOP_AUTO_DISTRIBUTION',
    USE_DYNAMIC_LEVEL_CONFIGS: 'USE_DYNAMIC_LEVEL_CONFIGS',
    INDUSTRY_PASS_SUBSCRIPTION_TIER_ID: 'INDUSTRY_PASS_SUBSCRIPTION_TIER_ID',
    FUEL_WITHDRAW_FEE_PERCENT: 'FUEL_WITHDRAW_FEE_PERCENT',
    FUEL_WITHDRAW_MIN_FEE_USD: 'FUEL_WITHDRAW_MIN_FEE_USD',
    DAILY_SPIN_WHEEL_CONFIG_ID: 'DAILY_SPIN_WHEEL_CONFIG_ID',
    SUPPORT_NATIVE_ENABLED: 'SUPPORT_NATIVE_ENABLED',
    CONSOLE_PLAY_REWARDS_ENABLED: 'CONSOLE_PLAY_REWARDS_ENABLED',
    SUPPORT_WIDGET_ACTIVATION: 'SUPPORT_WIDGET_ACTIVATION',
    SUPPORT_SLACK_INTEGRATION: 'SUPPORT_SLACK_INTEGRATION',
    DROP_IN_VISIBLE: 'DROP_IN_VISIBLE',
    DROP_IN_DIRECTORY_MIN_FOLLOWERS: 'DROP_IN_DIRECTORY_MIN_FOLLOWERS',
    AUTO_DROP_PROVISIONING_ENABLED: 'AUTO_DROP_PROVISIONING_ENABLED',
    EVENT_DEDUP_ENFORCE: 'EVENT_DEDUP_ENFORCE',
    WATCH_TIME_XP_PER_HOUR: 'WATCH_TIME_XP_PER_HOUR',
    DISCORD_COMMUNITY_GUILD_ID: 'DISCORD_COMMUNITY_GUILD_ID',
    DISCORD_COMMUNITY_INVITE_URL: 'DISCORD_COMMUNITY_INVITE_URL',
    MARKETING_SEND_CONCURRENCY: 'MARKETING_SEND_CONCURRENCY',
    TAX_COLLECTION_TRIGGER_USD: 'TAX_COLLECTION_TRIGGER_USD',
    WITHDRAW_IDENTITY_CHECK: 'WITHDRAW_IDENTITY_CHECK',
    PAYOUT_JURISDICTION_ENFORCE: 'PAYOUT_JURISDICTION_ENFORCE'
} as const;
export type SiteConfigurationKey = typeof SiteConfigurationKey[keyof typeof SiteConfigurationKey];


export function instanceOfSiteConfigurationKey(value: any): boolean {
    for (const key in SiteConfigurationKey) {
        if (Object.prototype.hasOwnProperty.call(SiteConfigurationKey, key)) {
            if (SiteConfigurationKey[key as keyof typeof SiteConfigurationKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SiteConfigurationKeyFromJSON(json: any): SiteConfigurationKey {
    return SiteConfigurationKeyFromJSONTyped(json, false);
}

export function SiteConfigurationKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteConfigurationKey {
    return json as SiteConfigurationKey;
}

export function SiteConfigurationKeyToJSON(value?: SiteConfigurationKey | null): any {
    return value as any;
}

export function SiteConfigurationKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): SiteConfigurationKey {
    return value as SiteConfigurationKey;
}

